import AccuracyTemplateDetailsView from "./AccuracyTemplateDetailsView";
import TemplateDetailsView from "./TemplateDetailsView";

export { TemplateDetailsView, AccuracyTemplateDetailsView };
